import React from 'react';
import { Box, Grid } from '@mui/material';
import FlowCanvas from './FlowCanvas.tsx';
import UpdateForm from './UpdateForm.tsx';

const Flow: React.FC = () => {

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={4} md={3}>
                <UpdateForm />
            </Grid>
            <Grid item xs={12} sm={8} md={9}>
                <FlowCanvas />
            </Grid>
        </Grid>
    );
};

export default Flow;

